var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10547 6.06543L5.80858 23.3661C5.84402 23.7261 6.14664 24.0004 6.50833 24.0004H17.4908C17.8524 24.0004 18.1551 23.726 18.1905 23.3661L19.8936 6.06543H4.10547Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5927 0H19.714C19.7132 0 19.7125 0 19.7118 0H4.28945C4.28842 0 4.28739 0 4.28641 0H3.4082C3.01989 0 2.70508 0.314812 2.70508 0.703125C2.70508 1.09144 3.01989 1.40625 3.4082 1.40625H3.64773L3.96794 4.65881H20.0329L20.3531 1.40625H20.5927C20.981 1.40625 21.2958 1.09144 21.2958 0.703125C21.2958 0.314812 20.981 0 20.5927 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.f1d579867400401878895eb682d8652e.svg";
export { ForwardRef as ReactComponent };